import { createApp } from "vue"
import { createPinia } from "pinia"
import axios from "axios"
import App from "./App.vue"
import router from "./router"
import "./styles/main.scss"

axios.defaults.xsrfCookieName = "csrftoken"
axios.defaults.xsrfHeaderName = "X-CSRFToken"

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.mount("#app")
